import { Route, Routes } from 'react-router-dom';

import NotFoundPage from 'common/pages/error/not-found';

interface Props {
  children: JSX.Element[] | JSX.Element;
}
function RoutesWithNotFound({ children }: Props) {
  return (
    <Routes>
      {children}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
export default RoutesWithNotFound;
